import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {BaseResponse} from '../models/respose/BaseResponse';
import {Task} from '../models/Task';

@Injectable({
  providedIn: 'root'
})
export class TaskService extends HttpService {

  constructor(http: HttpClient) {
    super(http);
  }

  getAll(): Observable<BaseResponse<Task[]>>{
    return this.get('tasks');
  }
}
